import { render, staticRenderFns } from "./FormBankSoal.vue?vue&type=template&id=2a78a98e"
import script from "./FormBankSoal.vue?vue&type=script&lang=js"
export * from "./FormBankSoal.vue?vue&type=script&lang=js"
import style0 from "./FormBankSoal.vue?vue&type=style&index=0&id=2a78a98e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports